import React from "react"

import {
  styled,
  Typography,
  useTheme
} from "@mui/material"

import { scrollToElement } from "../lib/utils"

const StyledNav = styled("nav", {
})(({ theme }) => {
  return {
    // display: "flex",
    position: "sticky",
    top: theme.spacing(2),
    flexBasis: 240,
    height: "fit-content",
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  }
})

const InPageNav = (props) => {
  const {
    items = []
  } = props

  const theme = useTheme()

  return (
    <StyledNav>
      <Typography
        sx={{ fontWeight: "bold", color: theme.palette.grey[600], textTransform: "uppercase" }}
        variant="body2"
      >
        Op deze pagina
      </Typography>
      <ul style={{ padding: theme.spacing(0.5, 0), marginTop: theme.spacing(1) }}>
        {items.map((item, ix) => {
          const id = item.question?.trim()?.replaceAll(" ", "_")?.replaceAll("?", "")?.toLowerCase()
          return (
            <li
              key={ix}
              id={`${id}_inpagenav`}
              style={{
                listStyle: "none",
                padding: theme.spacing(0.5, 0, 0.5, 2),
                borderLeftStyle: "solid",
                borderLeftWidth: 2,
                borderColor: theme.palette.grey[300]
              }}
            >
              <Typography
                variant="body2"
                onClick={() => {
                  window.history.pushState(null, "", `#${id}`)
                  scrollToElement(id, -16, "smooth")
                }}
                sx={{
                  cursor: "pointer",
                  textDecoration: "none",
                  color: theme.palette.grey[600],
                  "&:hover": {
                    textDecoration: "underline",
                    color: theme.palette.lintblauw.main
                  }
                }}
              >
                {item.question}
              </Typography>
            </li>
          )
        })}
      </ul>
    </StyledNav>
  )
}

export default React.memo(InPageNav)